import { TrainingApiBase } from '@/libs/apis/training/base';

export class TrainingInviteApi extends TrainingApiBase {
  createInvite(email) {
    return super.post('invite/', { invite_email: email }, 'Failed to create invite');
  }
}
